import axios from "axios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addUser } from "../utils/userSlice.js";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../utils/constants.js";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [retypedPassword, setRetypedPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isLoginForm, setIsLoginForm] = useState(true);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/login",
        {
          email,
          password,
        },
        { withCredentials: true }
      );
      dispatch(addUser(response.data));
      setError("");
      return navigate("/materialList");
    } catch (err) {
      setError(err?.response?.data);
    }
  };

  const handleSignup = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/signup",
        { firstName, lastName, email, password },
        { withCredentials: true }
      );
      dispatch(addUser(response.data));
      setIsLoginForm(true);
      setEmail("");
      setPassword("");
      setError("");
    } catch (err) {
      setError(err?.response?.data);
    }
  };

  const handleChangePassword = async () => {
    if (password !== retypedPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      await axios.post(BASE_URL + "/change-password", {
        email: email,
        newPassword: password,
        confirmPassword: retypedPassword,
      });

      alert("Password changed successfully! Please login again.");
      setIsForgotPassword(false);
      setIsLoginForm(true);
      setPassword("");
      setRetypedPassword("");
      setError("");
    } catch (err) {
      setError(err?.response?.data || "Something went wrong.");
    }
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  // console.log("email", email);
  // console.log("password", password);

  return (
    <div className="flex justify-center my-10">
  <div className="w-full max-w-md bg-gray-100 rounded-lg shadow-md p-8">
    <div>
      {!isForgotPassword && (
        <h2 className="text-2xl font-bold text-center mb-6">
          {isLoginForm ? "Login" : "Sign up"}
        </h2>
      )}

      {!isForgotPassword && !isLoginForm && (
        <>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-medium mb-1">
              First Name
            </label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
              placeholder="Type here"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-medium mb-1">
              Last Name
            </label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
              placeholder="Type here"
            />
          </div>
        </>
      )}

      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-medium mb-1">
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
          placeholder="Type here"
          autoComplete="off"
        />
      </div>

      {!isForgotPassword && (
        <div className="mb-4 relative">
          <label className="block text-gray-700 text-sm font-medium mb-1">
            Password
          </label>
          <div className="relative">
            <input
              autoComplete="new-password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-pink-500"
              placeholder="Type here"
            />
            <button
              type="button"
              onClick={togglePassword}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              tabIndex={-1}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
      )}

      {isForgotPassword && (
        <>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-medium mb-1">
              New Password
            </label>
            <input
              type="text"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
              placeholder="Type new password"
              autoComplete="new-password"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-medium mb-1">
              Confirm Password
            </label>
            <input
              type="password"
              value={retypedPassword}
              onChange={(e) => setRetypedPassword(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
              placeholder="Re-type new password"
              autoComplete="new-password"
            />
          </div>
        </>
      )}

      {error && (
        <p className="text-red-500 text-sm mb-4">{error}</p>
      )}

      <div className="flex justify-center gap-4 mt-4">
        {!isForgotPassword && (
          <button
            className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded"
            onClick={isLoginForm ? handleLogin : handleSignup}
          >
            {isLoginForm ? "Login" : "Sign Up"}
          </button>
        )}
        {isForgotPassword && (
          <button
            className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded"
            onClick={handleChangePassword}
          >
            Reset Password
          </button>
        )}
      </div>

      {!isForgotPassword && (
        <>
          {/* <p
            className="cursor-pointer text-sm mt-4 text-pink-600 hover:underline text-center"
            onClick={() => {
              setIsForgotPassword(true);
              setEmail("");
              setPassword("");
            }}
          >
            Forgot Password?
          </p> */}

          <p
            className="cursor-pointer text-sm mt-2 text-center text-gray-600 hover:underline"
            onClick={() => {
              setIsLoginForm((value) => !value);
              setEmail("");
              setPassword("");
            }}
          >
            {isLoginForm ? "New User? Sign Up" : "Sign In"}
          </p>
        </>
      )}

      {isForgotPassword && (
        <p
          className="cursor-pointer text-sm mt-4 text-pink-600 hover:underline text-center"
          onClick={() => {
            setIsForgotPassword(false);
            setError("");
            setPassword("");
            setEmail("");
            setRetypedPassword("");
          }}
        >
          Back to Login
        </p>
      )}
    </div>
  </div>
</div>

  );
};

export default Login;
